import { AssignmentListState } from './reducer'

export const getAssignmentList = (state: { assignmentList: AssignmentListState }) =>
  state.assignmentList.rows

export const getAssignmentListLoader = (state: { assignmentList: AssignmentListState }) =>
  state.assignmentList.isLoading

export const isAssignmentListStale = (state: { assignmentList: AssignmentListState }) =>
  state.assignmentList.stale
